









export default {
  name: 'CheckIcon',
  props: {
    color: {
      type: String,
      default: '#00ffdc'
    }
  }
}
